import React from 'react';
import { FaQuestionCircle } from 'react-icons/fa';

const HelpTab = () => {
  const faqs = [
    {
      category: 'Login and Account Access',
      questions: [
        {
          question: 'How do I log in to Yaqeen GenAI QA Monitor™?',
          answer: 'Click the login button on the top-right and enter your credentials provided by your admin. Multi-factor authentication may be enabled for added security.',
        },
        {
          question: 'How can I reset my password?',
          answer: 'Click "Forgot Password" on the login page. You’ll receive an email with instructions to create a new password.',
        },
      ],
    },
    {
      category: 'Navigation and Usage',
      questions: [
        {
          question: 'How do I navigate between modules?',
          answer: 'Use the left sidebar to switch between Client Scorecard, Prompt Management, Transcribe, Dashboards, Configuration, and Help.',
        },
        {
          question: 'How do I view real-time transcripts?',
          answer: 'Go to the Transcribe tab, upload an audio file, and click "Start Transcription". You can then select prompts and call the AI assistant.',
        },
      ],
    },
    {
      category: 'Preferences and Configuration',
      questions: [
        {
          question: 'How do I configure notification preferences?',
          answer: 'Under the Configuration tab, you can select disposition types and preferred channels (Email, SMS, Slack) for each client.',
        },
        {
          question: 'Can I add multiple subscribers for notifications?',
          answer: 'Yes. You can add multiple email subscribers under each notification rule by entering new emails and checking the box.',
        },
      ],
    },
    {
      category: 'Support and Issue Reporting',
      questions: [
        {
          question: 'How do I open a support case?',
          answer: 'Click on the Contact Us tab and fill out the support form. Our team will respond within 24–48 hours.',
        },
        {
          question: 'How do I request a new feature or enhancement?',
          answer: 'Use the Request for Change option in the Help tab or submit through the Contact form with a detailed description.',
        },
      ],
    },
  ];

  return (
    <div className="p-6">
      <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center">
        <FaQuestionCircle className="mr-2 text-blue-600" />
        Help & FAQs
      </h3>

      {faqs.map((section, idx) => (
        <div key={idx} className="mb-6">
          <h4 className="text-lg font-semibold text-gray-700 mb-2 border-b pb-1">{section.category}</h4>
          <ul className="space-y-3">
            {section.questions.map((q, i) => (
              <li key={i} className="bg-gray-50 p-4 rounded shadow-sm border border-gray-200">
                <p className="font-medium text-gray-800">{q.question}</p>
                <p className="text-sm text-gray-600 mt-1">{q.answer}</p>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default HelpTab;

